
import {   Spin } from 'antd';
import * as React from 'react'; 
import { LoadingOutlined } from '@ant-design/icons';

export interface IDynamicNoteProps {
 
    primaryColor: any;
    profileImageID: any;
    secondaryColor: any; 
    getProfileImage: (id: any) => any;
    defaultIcon: any;
}

export interface IDynamicNoteState {
    visible: boolean;
    ownerURL: any;
}


class DynamicNote extends React.Component<IDynamicNoteProps, IDynamicNoteState> {
    state = {
        visible: false,
        ownerURL: '',
    };

    async componentDidMount() {
       let ownerURL = await this.props.getProfileImage(this.props.profileImageID); 
        this.setState({ ownerURL: ownerURL });
    }

    render() {

        const antIcon = <LoadingOutlined style={{ fontSize: 19, color: this.props.primaryColor }} spin />;
        const ownerImage =
        this.state.ownerURL === '' || this.state.ownerURL === '_'
            ? this.state.ownerURL !== '_'
                ? <Spin indicator={antIcon}  >{this.props.defaultIcon}</Spin>
                : this.props.defaultIcon : <img style={{ width: '25px', height: '25px' }}
                    src={this.state.ownerURL} />




        return (<div>{ownerImage}</div>);
    }

}

export default DynamicNote;